import PropTypes from 'prop-types';
import React from 'react';

const Panel = ({heading, backgroundColor, children, nodeIndex}) => (
<div className={`panel ${backgroundColor}`} kye={nodeIndex}>
    <div className="panel-heading">
        <div className="panel-title">
            <h3>
              {heading}
            </h3>
        </div>
    </div>
    <div className="panel-body">
        {children}
    </div>
</div>
);

Panel.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  backgroundColor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  nodeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Panel;



// WEBPACK FOOTER //
// ./node_modules/@hpcare/component-wait-times/node_modules/@hppl/component-panel/index.jsx